import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  // Scrolling for many time slots and many rows
  scrollArea: {
    overflowX: "auto",
    overflowY: "auto",
    borderRadius: "5px",
    border: "1px solid rgba(0,0,0,0.1)",
    maxHeight: "60vh",
    background: "#fff",
  },

  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    fontSize: "13px",
    lineHeight: "18px",
    whiteSpace: "nowrap",

    // Sticky header with min widths so it doesn't look cramped when collapsed
    "& thead th": {
      position: "sticky",
      top: 0,
      zIndex: 2,
      background: "#f5f5f5",
      borderBottom: "1px solid #e5e5e5",
      padding: "8px",
      fontWeight: 700,
      textAlign: "left",
      minWidth: "80px",
      lineHeight: "24px",
    },

    // Body cell: reduced td padding; inner div will carry most spacing
    "& tbody td": {
      padding: "4px 6px",
      verticalAlign: "middle",
      borderBottom: "1px solid #eee",
    },

    // ✅ Zebra striping (row-based)
    "& tbody tr:nth-of-type(odd) td": {
      background: "#fafafa",
    },

    // Neutral row hover
    "& tbody tr:hover td": {
      background: "#f3f6ff",
    },

    // Sticky first column (horizontal) — BODY only
    "& tbody td:first-of-type": {
      position: "sticky",
      left: 0,
      zIndex: 1,
      background: "#fff",
      boxShadow: "1px 0 0 #eee",
    },

    // Sticky first column — HEADER first cell (top-left)
    "& thead th:first-of-type": {
      position: "sticky",
      top: 0,
      left: 0,
      zIndex: 5,
      background: "#f5f5f5",
      boxShadow: "1px 0 0 #ddd",
    },
  },

  // Expand/collapse button visuals
  toggleBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "28px",
    height: "28px",
    border: "none",
    background: "transparent",
    borderRadius: "6px",
    cursor: "pointer",
    ":hover": { background: "#c0d1ff" },
    ":focus-visible": { outline: "2px solid #0f6cbd", outlineOffset: "2px" },
  },

  chevron: {
    transition: "transform 150ms ease",
    transform: "rotate(0deg)",
    color: "#616161",
  },
  chevronExpanded: {
    transform: "rotate(90deg)",
  },

  // Inner content wrapper for cells: padding + rounded corners
  cellInner: {
    padding: "8px 10px",
    borderRadius: "8px",
    transition: "background 120ms ease, color 120ms ease",
  },

  // ---- Status-based cell styles ----
  cellModerate: {
    background: "#fff4cc",
    fontWeight: 500,
  },
  cellPoor: {
    background: "#ffd6d6",
    fontWeight: 700,
  },
});
